<template>
  <div class="card">
    <div class="card-body">
      <form @submit.prevent="formHandler">
        <div class="form-group">
          <label><b>Image Search</b></label>
          <input type="text" placeholder="Search Keywords" class="form-control" v-model="bind" @change="onChangeHandler"/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      value: "",
      bind: ""
    };
  },
  props: {
   method: { type: Function },
  },
  methods: {
    formHandler(event) {
      event.preventDefault();
      this.$emit('send', this.value);
      // form handling logic
    },
    onChangeHandler(event) {
        this.value = event.target.value;
    }
  },
  
};
</script>

<style lang="">
</style>